import { useState } from "react";
import emailjs from "emailjs-com";
import axios from "axios";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    // Replace these values with your actual EmailJS service and template IDs
    // const serviceID = "service_bqxwz3b";
    // const templateID = "template_50n1n8w";

    // emailjs.sendForm(serviceID, templateID, e.target, "QgmIaU9nW5RoQLZ2x").then(
    //   (result) => {
    //     console.log(result.text);
    //     // Handle success (e.g., show a success message to the user)
    //   },
    //   (error) => {
    //     console.log(error.text);
    //     // Handle error (e.g., show an error message to the user)
    //   }
    // );
    try{
      const response=await axios.post('http://localhost:5001/subscribe',{email});
      console.log(response.data);
      setEmail("")
    }
    catch(error){
console.error(error)
    }

    // Clear the input field after submission
    setEmail("");
  };

  return (
    <div className="grid md:grid-cols-2 my-20 from-[#E3FCFC] to-[#6EC2FF] rounded-lg mx-auto max-w-[1024px]">
      <div>
        <img
          className="mt-10 pl-10"
          src="newimage/banner/newslatter.png"
          alt="Newsletter"
        />
      </div>
      <div className="md:mr-10 mx-10">
        <h1 className="lg:text-[44px] text-[40px] leading-normal font-medium lg:mt-20">
          Get started with English HERE
        </h1>
        <p className="py-4 font-normal">
  Be the first to get exclusive offers and the latest news.<br />
  All updates will be sent from <span className="font-bold text-blue-600">Newsletter@radebjelan.com</span>
</p>


        <form onSubmit={handleSubmit}>
          <input
            type="email"
            id="email"
            name="user_name"
            value={email}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            placeholder="Enter your email"
            required
          />
          <button
            type="submit"
            className="bg-blue-700 my-2 py-2 px-4 justify-center rounded-lg text-white"
          >
            Subscribe
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewsletterForm;
